import e from 'express';
import React, { useEffect, useState } from 'react';
import { Modal, Form, Button, Table, Icon, Input, TextArea } from 'semantic-ui-react';

type CardTransactionSummaryModalProps = {
  BillingAndPackageSequence: any;
  BillingCarts: any;
  runSequence: any;
  setProp: any;
}

const CardTransactionSummaryModal = (props: CardTransactionSummaryModalProps) => {
  // const [packages, setPackages] = useState<any>([]);

  // const [formData, setFormData] = useState({
  //   email: '',
  //   address: '',
  //   taxId: '',
  // });

  const [disabled, setDisabled] = useState(false)

  const [edit, setEdit] = useState<any>({})
  const [validEmail, setValidEmail] = useState<boolean | null>(null);
  const [validAddress, setValidAddress] = useState<boolean | null>(null);
  const [validTaxId, setValidTaxId] = useState<boolean | null>(null);


  const setFormData = (form: any) => {
    console.log('form: ', form);
    props.setProp("BillingAndPackageSequence", {
      ...props.BillingAndPackageSequence,
      transactions: {
        ...props.BillingAndPackageSequence?.transactions,
        formData: form
      }
    })
  }

  useEffect(() => {
    let formDataInitial: any =  {}

    let e: any = {}
    if (!props.BillingAndPackageSequence?.transactions?.formData?.email) {
      e.email = true
    }

    if (!props.BillingAndPackageSequence?.transactions?.formData?.address_text) {
      if (props.BillingAndPackageSequence?.divisionProfile) {

          const getAddress = (profile: any) => {
    
            if (!profile) return "";

            const { business_type, branch_type, branch_name, business_name, first_name, last_name, address_text } = profile;

            let suffix = branch_type === "HEADQUARTER"
              ? "สำนักงานใหญ่"
              : branch_type === "BRANCH" && branch_name
                ? branch_name
                : "";

            let line1 = business_type === "INDIVIDUAL"
              ? `${first_name || ""} ${last_name || ""}`.trim()
              : business_name || "";

            if (suffix) line1 = `${line1} ${suffix}`;

            return `${line1}\n${address_text || ""}`.trim();
          }

          let address = getAddress(props.BillingAndPackageSequence?.divisionProfile)
          formDataInitial.address = address;
          // setFormData({ ...props.BillingAndPackageSequence?.transactions?.formData, address })
      } else {
        e.address = false
      }
      //
      
    }

    if (!props.BillingAndPackageSequence?.transactions?.formData?.taxId) {
      if (props.BillingAndPackageSequence?.divisionProfile) {
          // 
          formDataInitial.taxId = props.BillingAndPackageSequence?.divisionProfile?.tax_payer_id
      } else {
        e.taxId = false
      }
    }
    if (Object.keys(formDataInitial)?.length > 0) {
      setFormData({ ...props.BillingAndPackageSequence?.transactions?.formData, ...formDataInitial})
    }

    setEdit(e)



  }, [props.BillingAndPackageSequence?.divisionProfile])


  const handleQuantityChange = async (id: string, delta: number) => {
    setDisabled(true)
    await props.runSequence({sequence: "BillingAndPackage", action: "EDIT_QTY_CARTS", id, delta})
    setDisabled(false)
  };

  const handleDelete = (id: string) => {
      props.runSequence({sequence: "BillingAndPackage",
        action: "REMOVE_PACKAGE_CARTS", id})
  };

  const calculateTotal = () => {
    return (props.BillingCarts?.items || []).filter((i: any) => i.status === "BILLED").reduce((sum: number, cart: any) => {
      const itemTotal = Number(cart.price_included_vat.replace(/,/g, ''))
      return sum + itemTotal;
    }, 0);
  };

  let sum = calculateTotal().toLocaleString('en-US', { minimumFractionDigits: 2 })

  const validateEmail = () => {
    const isValidEmail = checkEmailString(props.BillingAndPackageSequence?.transactions?.formData?.email)
    setValidEmail(isValidEmail)
    return isValidEmail
  }

  const validateTaxId = () => {
    const isValidTaxId = checkTaxId13Digits(props.BillingAndPackageSequence?.transactions?.formData?.taxId) || !!props.BillingAndPackageSequence?.divisionProfile?.tax_payer_id
    setValidTaxId(isValidTaxId)
    return isValidTaxId
  }

  const validateAddress = () => {
    const isValidAddress = !!props.BillingAndPackageSequence?.transactions?.formData?.address || !!fullAddress
    setValidAddress(isValidAddress)
    return isValidAddress
  }

  const validForm = () => {
    return { isValidEmail : validateEmail(),isValidAddress: validateAddress(),  isValidTaxId: validateTaxId() }
  }

  const handleSubmit = () => {
    // console.log('Processing payment...', { formData, packages });
    const { isValidEmail, isValidAddress, isValidTaxId } = validForm()

    if (isValidEmail && isValidAddress && isValidTaxId) {
      props.runSequence({
        sequence: "BillingAndPackage",
        action: "PAID",
      })
    }
  };

  // Simple email validation function
  function checkEmailString(email?: string) {
    if (!email) {
      return false
    }
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  function checkTaxId13Digits(taxId?: string): boolean {

    if (!taxId) {
      return false
    }

    // Remove spaces and dashes
    taxId = taxId.replace(/[\s-]/g, "");
    // Check only: must be exactly 13 digits
    return /^\d{13}$/.test(taxId)
  }


  
  const fullAddress = (() => {
    const profile = props.BillingAndPackageSequence?.divisionProfile;
    if (!profile) return "";

    const { business_type, branch_type, branch_name, business_name, first_name, last_name, address_text } = profile;

    let suffix = branch_type === "HEADQUARTER"
      ? "สำนักงานใหญ่"
      : branch_type === "BRANCH" && branch_name
        ? branch_name
        : "";

    let line1 = business_type === "INDIVIDUAL"
      ? `${first_name || ""} ${last_name || ""}`.trim()
      : business_name || "";

    if (suffix) line1 = `${line1} ${suffix}`;

    return `${line1}\n${address_text || ""}`.trim();
  })();


  let disabledPaid = !(Number(sum.replace(/,/g, '')) > 0) // &&
  // isValidEmail(props.BillingAndPackageSequence?.transactions?.formData?.email) &&
  // isValidThaiTaxID(props.BillingAndPackageSequence?.transactions?.formData?.taxId))

  const onClose = () => {
    props.setProp("BillingAndPackageSequence", {
      ...props.BillingAndPackageSequence,
      openTransactionModal: false,
      transactions: {
        ...props.BillingAndPackageSequence.transactions,
        formData: {},
      }
    })
  }

  return (
    <Modal
      open={props.BillingAndPackageSequence?.openTransactionModal}
      onClose={onClose}
      size="large"
      style={{ maxWidth: '1200px' }}
      closeOnDimmerClick={false}
    >
      <Modal.Header style={{
        fontSize: '28px',
        fontWeight: 'bold',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <span>สรุปยอดรายการ</span>
        <Icon name="close" style={{ cursor: 'pointer' }} onClick={onClose} />
      </Modal.Header>

      <Modal.Content>
        <div style={{ marginBottom: '20px', fontSize: '14px' }}>
          ใบกำกับภาษีและข้อมูลติดต่อ <span style={{color: "red"}}>** กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนดำเนินการชำระเงิน **</span> 
        </div>

        <Form style={{
          background: '#f9f9f9',
          padding: '30px',
          borderRadius: '8px',
          marginBottom: '30px'
        }}>
          <Form.Field required>
            <label style={{ fontSize: '15px', fontWeight: 'bold', marginBottom: '10px' }}>
              อีเมล์ {validEmail === false ? <span style={{ color: "red", fontSize: "smaller", fontStyle: "italic", fontWeight: "normal" }}> email ไม่ถูกต้อง</span> : ""}
            </label>
            <div style={{ display: 'flex', alignItems: 'center' }} onBlur={() => {
              if (!!props.BillingAndPackageSequence?.transactions?.formData?.email) {
                setEdit({ ...edit, email: false })
                validateEmail()
              }
            }}>
              {edit?.email ? <Input
                fluid
                value={props.BillingAndPackageSequence?.transactions?.formData?.email}
                onChange={(e) => setFormData({ ...props.BillingAndPackageSequence?.transactions?.formData, email: e.target.value })}
                style={{ flex: 1 }}
              /> :
                <> <span style={{ color: validEmail === false ? "red" : "black" }}> {props.BillingAndPackageSequence?.transactions?.formData?.email} </span>

                  <Icon name="pencil" style={{ marginLeft: '10px', color: '#999', cursor: "pointer" }} onClick={() => {
                    setEdit({ ...edit, email: true })
                  }} />
                </>
              }
            </div>
          </Form.Field>

          <Form.Field required style={{ marginTop: '20px' }}>
            <label style={{ fontSize: '15px', fontWeight: 'bold', marginBottom: '10px' }}>
              ที่อยู่ในการออกใบกำกับภาษี {validAddress === false ? <span style={{ color: "red", fontSize: "smaller", fontStyle: "italic", fontWeight: "normal" }}> กรุณากรอกที่อยู่จัดส่ง</span> : ""}
            </label>
            <div style={{ display: 'flex', alignItems: 'flex-start' }} onBlur={() => {
              if (!!props.BillingAndPackageSequence?.transactions?.formData?.address) {
                setEdit({ ...edit, address: false })
                validateAddress()
              }
            }}>
              <Form style={{ display: 'flex', width: "100%" }}>
                {edit?.address ? <TextArea
                  value={props.BillingAndPackageSequence?.transactions?.formData?.address}
                  onChange={(e) => setFormData({ ...props.BillingAndPackageSequence?.transactions?.formData, address: e.target.value })}
                  rows={3}
                  style={{ flex: 1 }}
                  fluid /> :
                  <div style={{
                    display: "flex",
                    alignItems: "flex-end",
                    whiteSpace: "pre-wrap"
                  }}>
                    <span style={{ 
                      color: validAddress === false ? "red" : "black",
                      flex: 1,
                      whiteSpace: "pre-wrap"
                    }}>
                      {props.BillingAndPackageSequence?.transactions?.formData?.address}
                    </span>
                    <Icon 
                      name="pencil"
                      style={{ marginLeft: "20px", color: "#999", cursor: "pointer", marginBottom: "5px" }}
                      onClick={() => setEdit({ ...edit, address: true })}
                    />
                  </div>
                }
              </Form>
            </div>
          </Form.Field>

          <Form.Field required style={{ marginTop: '20px' }}>
            <label style={{ fontSize: '15px', fontWeight: 'bold', marginBottom: '10px' }}>
              เลขประจำตัวผู้เสียภาษี { validTaxId === false ? <span style={{ color: "red", fontSize: "smaller", fontStyle: "italic", fontWeight: "normal" }}> เลขประจำตัวผู้เสียภาษีไม่ถูกต้อง</span> : ""}
            </label>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }} onBlur={() => {
              if (!!props.BillingAndPackageSequence?.transactions?.formData?.taxId) {
                setEdit({ ...edit, taxId: false })
                validateTaxId()
              }
            }}>

              {edit?.taxId ?
                <Input
                  value={props.BillingAndPackageSequence?.transactions?.formData?.taxId }
                  onChange={(e) => setFormData({ ...props.BillingAndPackageSequence?.transactions?.formData, taxId: e.target.value })}
                  style={{ flex: 1 }}
                /> : <>
                  <span style={{ color: validTaxId === false ? "red" : "black" }}> {props.BillingAndPackageSequence?.transactions?.formData?.taxId} </span>
                  <Icon name="pencil" style={{ marginLeft: '10px', color: '#999', cursor: "pointer" }} onClick={() => {
                    setEdit({ ...edit, taxId: true })
                  }} />

                </>}
            </div>
          </Form.Field>
        </Form>

        <Table basic="very" style={{ marginTop: '20px' }}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={4}>Name</Table.HeaderCell>
              <Table.HeaderCell width={3} textAlign="center">จำนวน</Table.HeaderCell>
              <Table.HeaderCell width={2} textAlign="right">ราคา</Table.HeaderCell>
              <Table.HeaderCell width={2} textAlign="right">ภาษีมูลค่าเพิ่ม</Table.HeaderCell>
              <Table.HeaderCell width={2} textAlign="right">ยอดรวมภาษีมูลค่าเพิ่ม</Table.HeaderCell>
              <Table.HeaderCell width={1} textAlign="center">Actions</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {(props.BillingCarts?.items || [])
              .filter((i:any) => i.status === "BILLED" )
              ?.sort((a: any, b: any) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime() )
              ?.map((pkg: any) => (
              <Table.Row key={pkg.id}>
                <Table.Cell>
                  <div style={{ fontWeight: 'bold' }}>{pkg.package.name}</div>
                  <div style={{ color: '#999', fontSize: '13px' }}>{pkg.package.credit_amount} Credit</div>
                </Table.Cell>
                <Table.Cell textAlign="center">
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                    <Button
                      icon
                      size="mini"
                      basic
                      circular
                      onClick={() => handleQuantityChange(pkg.id, -1)}
                      disabled={Number(pkg.quantity) <= 0 || disabled }
                    >
                      <Icon name="minus" disabled={Number(pkg.quantity) <= 0 || disabled}/>
                    </Button>
                    <span style={{
                      minWidth: '40px',
                      textAlign: 'center',
                      fontSize: '16px'
                    }}>
                      {Number(pkg.quantity)}
                    </span>
                    <Button
                      icon
                      size="mini"
                      basic
                      circular
                      onClick={() => handleQuantityChange(pkg.id, 1)}
                      disabled={disabled}
                    >
                      <Icon name="plus" disabled={disabled}/>
                    </Button>
                  </div>
                </Table.Cell>
                <Table.Cell textAlign="right">
                  ฿ {pkg.price.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </Table.Cell>
                <Table.Cell textAlign="right">
                  {pkg.price_vat}
                </Table.Cell>
                <Table.Cell textAlign="right">
                  ฿ {((Number(pkg.price_included_vat?.replace(/,/g, '')))).toLocaleString('th-TH', { minimumFractionDigits: 2 })}
                </Table.Cell>
                <Table.Cell textAlign="center">
                  <Button
                    icon
                    basic
                    onClick={() => handleDelete(pkg.id)}
                    disabled={disabled}
                  >
                    <Icon name="trash alternate outline" />
                  </Button>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>

        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '30px',
          paddingTop: '20px',
          borderTop: '1px solid #e0e0e0'
        }}>
          <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
            ยอดต้องชำระทั้งสิ้น
          </span>
          <span style={{ fontSize: '28px', fontWeight: 'bold', color: '#ff69b4' }}>
            {sum}
          </span>
        </div>
      </Modal.Content>

      <Modal.Actions style={{ padding: '20px 30px' }}>
        <Button
          size="large"
          style={{
            background: '#9e9e9e',
            color: '#fff',
            padding: '15px 40px',
            fontSize: '16px'
          }}
          onClick={onClose}
        >
          ย้อนกลับ
        </Button>
        <Button
          size="large"
          style={{
            background: '#ff69b4',
            color: '#fff',
            padding: '15px 40px',
            fontSize: '16px'
          }}
          disabled={disabledPaid}
          onClick={handleSubmit}
        >
          ดำเนินการชำระเงิน
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default CardTransactionSummaryModal;
